import { MiembroFamilia } from '../../../servicios/lugares.service';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-grupo-familiar-titulares',
  templateUrl: './grupo-familiar-titulares.component.html',
  styleUrls: ['./grupo-familiar-titulares.component.scss']
})
export class GrupoFamiliarTitularesComponent implements OnInit {

  @Input() grupoFamiliar: MiembroFamilia[];
  @Input() cargando: boolean = false;
  @Output() onCambiarInvitadosPermitidos = new EventEmitter();
  @Output() onEliminarTitular = new EventEmitter<MiembroFamilia>();
  esCitofonia: boolean;
  currentFotoMiembro = null;
  miembroConfirmandoId: number | null = null;

  constructor(
    private readonly location: Location,
  ) { }

  ngOnInit(): void {
    this.esCitofonia = this.location.path().includes("citofonia");
  }
    
  public numSequence(n: number): Array<number> {
    return Array(n);
  }

  
  handleCambiarInvitadosPermitidos(miembro: MiembroFamilia) {
    this.onCambiarInvitadosPermitidos.emit(miembro);
  }

  iniciarConfirmacion(miembro: MiembroFamilia) {
    this.miembroConfirmandoId = miembro.id;
  }

  cancelarConfirmacion() {
    this.miembroConfirmandoId = null;
  }

  confirmarEliminar(miembro: MiembroFamilia) {
    this.miembroConfirmandoId = null;
    this.onEliminarTitular.emit(miembro);
  }

  public telefonoWhatsApp(miembro: MiembroFamilia) {
    return miembro.indicative.substr(1) + miembro.phone;
  }

}
